export default __webpack_public_path__ + "static/media/Black Francolin.d7449774.jpg";